import { PrinterPosPauseIcon } from './PrinterPosPauseIcon';

/**
 * author: Colton Wiscombe
 * id FC8CF9C9-3DCD-46DC-8B3C-A4000A7B00DD
 * name printer-pos-pause
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-pause.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptPauseIcon = PrinterPosPauseIcon;
export default PrinterReceiptPauseIcon